export default address =>
  `${address.address_line_1}, ${address.postal_code}, ${address.locality}, ${address.country_code}`;
